import { useQuery } from 'react-query'; 
import axiosInstance from './axiosInstance';

const fetchClients = async ({ queryKey }) => {
  const [, page, name] = queryKey;
  const response = await axiosInstance.get(
    `/super-admin/client-management/client-with-pagination?page=${page}&name=${name || ''}`
  );
  return response.data.payload;
};


export const useGetClients = (page, name) => {
  return useQuery(['clients', page, name], fetchClients);
};

